<template>
	<div>
        <vue-headful :title="'Dashboard :: MeritEHS'" />

	    <h4 class="mt-2 mb-4">
	    	<ol class="breadcrumb font-weight-bold m-0">
	    		<li class="breadcrumb-item active">
	    			<i class="fa fa-dashboard"></i> Dashboard</a>
	    		</li>
	    	</ol>
	    </h4>

	   	<div class="row">
	   		<div class="col-12">
                <div v-if="this.$store.state.user.permissions.length === 0 || (this.$store.state.user.permissions.length === 1 && this.$store.state.user.permissions[0] === 'correctiveActions.view.assigned')">
                    <div class="card">
                        <div class="card-header">
                            My Assigned Corrective Actions ({{ actionCount }})
                        </div>
                        <div class="card-body">
                            <corrective-action-list ref="correctiveActionDashList" @correctiveActionCount="correctiveActionCount" />
                        </div>
                    </div>
                </div>

                <draggable v-else :list="active_cards" direction="horizontal" handle=".handle" class="row" @update="sortTile" @start="is_dragging = true" @end="is_dragging = false">
					<div v-for="(card,index) in active_cards" class="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-4">
                        <b-card v-if="card.permissions.length === 0 || $root.hasPermission(card.permissions)" :border-variant="curr_index == index ? 'dark' : 'light'" :text-variant="curr_index == index ? '' : 'muted'" style="cursor: pointer; height: 100%;" @click="curr_index = index" header-class="pr-2 pb-2">
                            <div slot="header" class="d-flex justify-content-between">
                                <strong style="font-size: 16px;">{{ getTileName(card) }}</strong>
                                <div>
                                    <i class="fa fa-align-justify handle"></i>
                                    <button @click.stop="deleteTile(index)" class="btn btn-sm btn-link" :class="curr_index == index ? 'text-dark' : 'text-muted'"><i style="font-size: 18px;" class="fa fa-times"></i></button>
                                </div>
                            </div>
                            <b-card-body style="overflow-x: auto;">
                                <div class="container p-0 h-100">
                                    <div v-if="card.tile_type && card.tile_type == 'weather'" class="row h-100 align-items-center justify-content-between" style="padding-left: .75rem; padding-right: .75rem;">
                                        <div class="text-center">
                                            <h1>{{ card.temp === undefined || card.temp === null ? '-' : card.temp}}˚</h1>
                                        </div>
                                        <div class="text-center">
                                            <img v-if="card.icon" :src="`http://openweathermap.org/img/wn/${card.icon}@2x.png`" style="margin-top: -1rem;" />
                                        </div>
                                        <div class="text-center">
                                            <h3>
                                                {{ card.temp_max === undefined || card.temp_max === null ? '-' : card.temp_max}}˚/{{ card.temp_min === undefined || card.temp_min === null ? '-' : card.temp_min}}˚
                                            </h3>
                                        </div>
                                    </div>
                                    <div v-else-if="card.tile_type && card.tile_type == 'osha'" class="row h-100 align-items-center">
                                        <div class="text-center col-12">
                                            <v-clamp :max-lines="3" tag="h4">{{ card.first_item === undefined || card.first_item === null ? '' : card.first_item}}</v-clamp>
                                        </div>
                                    </div>
                                    <div v-else class="h-100 align-items-center">
                                        <div class="row">
                                            <div class="text-center" :class="card.prev_count === undefined || card.prev_count === null ? 'col-12' : 'col-4'">
                                                <span v-if="card.prev_count !== undefined && card.prev_count !== null">Curr</span><br>
                                                <h2>{{ card.count === undefined || card.count === null ? '-' : card.count}}</h2>
                                            </div>
                                            <div v-if="card.prev_count !== undefined && card.prev_count !== null" class="text-center col-4">
                                                Prev<br>
                                                <h2>{{ card.prev_count }}</h2>
                                            </div>
                                            <div v-if="card.prev_count !== undefined && card.prev_count !== null" class="text-center col-4" :class="getCardTextColor(card, curr_index == index)">
                                                Chng<br>
                                                <h2>
                                                    <i v-if="card.count > (card.prev_count || 0)" class="fa fa-arrow-up"></i>
                                                    <i v-else-if="card.count < (card.prev_count || 0)" class="fa fa-arrow-down"></i>
                                                    {{ Math.abs((card.count || 0) - (card.prev_count || 0)) }}
                                                </h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-card-body>
                        </b-card>
					</div>
                    <div v-if="!is_dragging" class="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-4">
                        <b-card class="border-light" style="cursor: pointer; height: 100%;" @click="openModal = true">
                            <div class="container h-100 w-100 text-center"><div class="row mx-0 justify-content-center align-items-center text-default h-100 w-100"><i class="fa fa-plus" style="font-size: 40px;"></i></div></div>
                        </b-card>
                    </div>
                </draggable>

				<div class="card col-12 mt-2" v-show="curr_index !== null && hasCard">
					<div v-for="(card,index) in active_cards" v-show="curr_index == index">
                        <template v-if="card.permissions.length === 0 || $root.hasPermission(card.permissions)">
							<div class="card-header">
								<strong>{{ getCardName(card) }}</strong>
							</div>
							<div class="card-body">
								<!-- weather, NO LIST -->
								<div v-if="card.key == 'my_corrective_actions'">
									<dash-corrective-action-list @correctiveActionCount="$set(card, 'count', $event)" assetType="Dashboard" />
								</div>
								<div v-if="card.key == 'safety_meetings'" >
									<dash-safety-meeting-list @safetyMeetingListCount="$set(card, 'count', $event)" @prevSafetyMeetingListCount="$set(card, 'prev_count', $event)" :timeFilter="card.filters ? card.filters.timeframe : null" :savedFilterId="card.savedFilterId" ref="dashItem" />
								</div>
								<div v-if="card.key == 'inspections'">
									<dash-inspection-list @inspectionListCount="$set(card, 'count', $event)" @prevInspectionListCount="$set(card, 'prev_count', $event)" :timeFilter="card.filters ? card.filters.timeframe : null" :savedFilterId="card.savedFilterId" ref="dashItem" />
								</div>
								<div v-if="card.key == 'incidents'">
									<dash-incident-list @incidentListCount="$set(card, 'count', $event)" @prevIncidentListCount="$set(card, 'prev_count', $event)" :timeFilter="card.filters ? card.filters.timeframe : null" :savedFilterId="card.savedFilterId" ref="dashItem" />
								</div>
								<div v-if="card.key == 'inspection_score'">
                                    <dash-inspection-score-list @inspectionScoreListCount="$set(card, 'count', $event+'%')" :timeFilter="card.filters ? card.filters.timeframe : null" :savedFilterId="card.savedFilterId" ref="dashItem" />
                                </div>
                                <div v-if="card.key == 'osha_news'">
                                    <dash-osha-news-list @firstNewsItem="$set(card, 'first_item', $event)"/>
                                </div>
								<div v-if="card.key == 'noncompliant_items'">
									<dash-non-compliant-list @noncompliantListCount="$set(card, 'count', $event)" @prevNoncompliantListCount="$set(card, 'prev_count', $event)" :timeFilter="card.filters.timeframe" />
								</div>
								<div v-if="card.key == 'corrective_actions'">
									<dash-corrective-action-list @correctiveActionCount="$set(card, 'count', $event)" @prevCorrectiveActionCount="$set(card, 'prev_count', $event)" :timeFilter="card.filters ? card.filters.timeframe : null" :savedFilterId="card.savedFilterId" ref="dashItem" />
								</div>
                                <div v-if="card.key == 'incident_types'">
                                    <dash-incident-type-list @incidentTypeListCount="$set(card, 'count', $event)" @prevIncidentTypeListCount="$set(card, 'prev_count', $event)" :timeFilter="card.filters ? card.filters.timeframe : null" :savedFilterId="card.savedFilterId" ref="dashItem" />
                                </div>
                                <div v-if="card.key == 'incident_employees'">
                                    <dash-incident-employee-list @incidentEmployeeListCount="$set(card, 'count', $event)" @prevIncidentEmployeeListCount="$set(card, 'prev_count', $event)" :timeFilter="card.filters ? card.filters.timeframe : null" :savedFilterId="card.savedFilterId" ref="dashItem" />
                                </div>
                                <div v-if="card.key == 'incident_jobsites'">
                                    <dash-incident-jobsite-list @incidentJobsiteListCount="$set(card, 'count', $event)" @prevIncidentJobsiteListCount="$set(card, 'prev_count', $event)" :timeFilter="card.filters ? card.filters.timeframe : null" :savedFilterId="card.savedFilterId" ref="dashItem" />
                                </div>
								<div v-if="card.key == 'my_equipment'">
									<checked-equipment-list @checkedEquipmentListCount="$set(card, 'count', $event)" assetType="Assignee" :assetId="employeeId" />
								</div>
								<div v-if="card.key == 'assigned_equipment'">
									<checked-equipment-list @checkedEquipmentListCount="$set(card, 'count', $event)" assetType="Assigner" />
								</div>
								<div v-if="card.key == 'pending_subcontractors'">
									<dash-subcontractor-list assetType="Dashboard" @subcontractorCount="$set(card, 'count', $event)" />
								</div>
								<div v-if="card.key == 'expiring_subcontractors'">
									<dash-subcontractor-list assetType="Expiring" @subcontractorCount="$set(card, 'count', $event)" />
								</div>
								<div v-if="card.key == 'employee_recognitions'">
									<dash-employee-recognition-list @recognitionListCount="$set(card, 'count', $event)" @prevRecognitionListCount="$set(card, 'prev_count', $event)" :timeFilter="card.filters.timeframe" />
								</div>
								<div v-if="card.key == 'employee_disc_actions'">
									<dash-disciplinary-list @disciplinaryListCount="$set(card, 'count', $event)" @prevDisciplinaryListCount="$set(card, 'prev_count', $event)" :timeFilter="card.filters.timeframe" />
								</div>
							</div>
                        </template>
					</div>
				</div>
	   		</div>
	   	</div>

	   	<b-modal v-model="openModal" title="New Tile" size="lg" ok-title="Add Tile" lable="id" :resetOnOptionsChange="false" ok-variant="success" :settings="{minimumInputLength: 3, }" no-fade :ok-disabled="selected_option == null" @hidden="selected_option = null; selected_index = null" @ok="addTile" :scrollable="true">
	   		<div class="row">
	   			<div class="col-xl-4 col-lg-6 border-right" style="max-height: 300px; overflow-y: auto;">
		   			<div v-for="(option, index) in card_options" class="mb-3">
		   				<template v-if="option.permissions.length === 0 || $root.hasPermission(option.permissions)">
			   				<b-button :variant="selected_index == index ? 'secondary' : 'default'" block @click="selected_option = option; selected_index = index">{{ option.name }}</b-button>
			   			</template>
			   		</div>
			   	</div>
			   	<div v-if="selected_option" class="col-xl-8 col-lg-6">
                    <template v-if="selected_option.filter_options">
    			   		<div class="row" v-for="(config, key) in selected_option.filter_options">
    			   			<label class="col-md-3 col-sm-4 col-form-label text-sm-right">{{ config.label }}</label>
    			   			<div class="col-sm-8">
                                <template v-if="config.type == 'select'">
        					   		<select class="form-control" v-model="selected_option.filters[key]" @change="selected_option.savedFilterId = null">
                                        <option :value="null">
                                            -- Select a {{ config.label }} --
                                        </option>
        					   		    <option v-for="value in config.options" :value="value">
        					   		        {{ value }}
        					   		    </option>
        					   		</select>
                                </template>
                                <template v-else-if="config.type == 'ajax'">
                                    <div class="input-group-sm">
                                        <v-select v-model="ajax_item" :filterable="false" @search="onSearch" @input="onChange" :options="options" label="id" :placeholder="`Search ${config.placeholder}`">
                                            <template slot="no-options">
                                                Search {{ config.placeholder }}
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ displayOption(key, option) }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ displayOption(key, option) }}
                                                </div>
                                            </template>
                                        </v-select>
                                    </div>
                                </template>
    					   	</div>
    				   	</div>
                    </template>
                    <template v-if="selected_option.filter_options && selected_option.savedFilterType">
                        <h5 class="text-center my-3">OR</h5>
                    </template>
                    <template v-if="selected_option.savedFilterType">
                        <div class="row">
                            <label class="col-md-3 col-sm-4 col-form-label text-sm-right">Saved Filter</label>
                            <div class="col-sm-8">
                                <select class="form-control" v-model="selected_option.savedFilterId" @change="selected_option.filters.timeframe = null">
                                    <option :value="null">-- Select a Saved Filter --</option>
                                    <option v-for="filter in savedFilters(selected_option.savedFilterType)" :value="filter.id">
                                        {{ filter.filter_name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </template>
			   	</div>
	   		</div>
	   	</b-modal>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';

    export default {
        components: {
            draggable,
        },

        data: function() {
            return {
                options: [],
                ajax_item: null,
                debounce_lock: 0,
            	openModal: false,
                loading: true,
                actions: [],
                selected_option: null,
                selected_index: null,
                curr_index: null,
                is_dragging: false,
                active_cards: [],
                actionCount: null,
                card_options: {
                    inspection_score: {
                        name: 'Average Inspection Score',
                        key: 'inspection_score',
                        permissions: ['inspections.manage'],
                        filter_options: {
                            timeframe: {
                                options: ['MTD', 'YTD'],
                                label: 'Time Period',
                                type: 'select',
                            },
                        },
                        filters: {
                            timeframe: null,
                        },
                        savedFilterType: 'Inspection',
                        savedFilterId: null,
                    },
                	corrective_actions: {
                		name: 'Corrective Actions',
                		key: 'corrective_actions',
                		permissions: ['correctiveActions.view.browse', 'correctiveActions.view.assigned'],
                		filter_options: {
                			timeframe: {
                				options: ['MTD', 'YTD'],
                				label: 'Time Period',
                                type: 'select',
                			},
                		},
                		filters: {
	            			timeframe: null,
	            		},
	            		reverse_colors: true,
                	},
                	employee_disc_actions: {
                		name: 'Disciplinary Actions',
                		key: 'employee_disc_actions',
                		permissions: ['employees.disciplinary.view'],
                		filter_options: {
                			timeframe: {
                				options: ['MTD', 'YTD'],
                				label: 'Time Period',
                                type: 'select',
                			},
                		},
                		filters: {
                			timeframe: 'MTD',
                		},
                		reverse_colors: true,
                	},
                	employee_recognitions: {
                		name: 'Employee Recognitions',
                		key: 'employee_recognitions',
                		permissions: ['recognitions.view'],
                		filter_options: {
                			timeframe: {
                				options: ['MTD', 'YTD'],
                				label: 'Time Period',
                                type: 'select',
                			},
                		},
                		filters: {
                			timeframe: 'MTD',
                		},
                	},
                    incident_employees: {
                        name: 'Employees w/ Incidents',
                        key: 'incident_employees',
                        permissions: ['incidents.manage', 'employees.manage'],
                        filter_options: {
                            timeframe: {
                                options: ['MTD', 'YTD'],
                                label: 'Time Period',
                                type: 'select',
                            },
                        },
                        filters: {
                            timeframe: null,
                        },
                        savedFilterType: 'Incident',
                        savedFilterId: null,
                        reverse_colors: true,
                    },
                	assigned_equipment: {
                		name: 'Equipment Assigned By Me',
                		key: 'assigned_equipment',
                		permissions: ['tracking.all'],
                		filter_options: {},
                		filters: {},
                	},
                	my_equipment: {
                		name: 'Equipment Assigned To Me',
                		key: 'my_equipment',
                		permissions: ['tracking.own', 'tracking.all'],
                		filter_options: {},
                		filters: {},
                	},
                	expiring_subcontractors: {
                		name: 'Expiring Subcontractors',
                		key: 'expiring_subcontractors',
                		permissions: ['subcontractors.manage'],
                		filter_options: {},
                		filters: {},
                	},
                	incidents: {
                		name: 'Incidents',
                		key: 'incidents',
                		permissions: ['incidents.view.browse', 'incidents.view.own'],
                		filter_options: {
                			timeframe: {
                				options: ['MTD', 'YTD'],
                				label: 'Time Period',
                                type: 'select',
                			},
                		},
                		filters: {
	            			timeframe: null,
	            		},
                        savedFilterType: 'Incident',
                        savedFilterId: null,
	            		reverse_colors: true,
                	},
                	inspections: {
                		name: 'Inspections',
                		key: 'inspections',
                		permissions: ['inspections.view.browse', 'inspections.view.own'],
                		filter_options: {
                			timeframe: {
                				options: ['MTD', 'YTD'],
                				label: 'Time Period',
                                type: 'select',
                			},
                		},
                		filters: {
	            			timeframe: null,
	            		},
                        savedFilterType: 'Inspection',
                        savedFilterId: null,
                	},
                	incident_jobsites: {
                        name: 'Jobsites w/ Incidents',
                        key: 'incident_jobsites',
                        permissions: ['incidents.manage', 'jobsites.manage'],
                        filter_options: {
                            timeframe: {
                                options: ['MTD', 'YTD'],
                                label: 'Time Period',
                                type: 'select',
                            },
                        },
                        filters: {
                            timeframe: null,
                        },
                        savedFilterType: 'Incident',
                        savedFilterId: null,
                        reverse_colors: true,
                    },
                	noncompliant_items: {
                		name: 'Non-compliant Items',
                		key: 'noncompliant_items',
                		permissions: ['reports.view'],
                		filter_options: {
                			timeframe: {
                				options: ['MTD', 'YTD'],
                				label: 'Time Period',
                                type: 'select',
                			},
                		},
                		filters: {
	            			timeframe: 'MTD',
	            		},
	            		reverse_colors: true,
                	},
                	my_corrective_actions: {
                		name: 'Open Corrective Actions',
                		key: 'my_corrective_actions',
                		permissions: ['correctiveActions.view.assigned'],
                		filter_options: {},
                	},
                    osha_news: {
                        name: 'OSHA News',
                        key: 'osha_news',
                        permissions: [],
                        filter_options: {},
                        filters: {},
                        tile_type: 'osha',
                    },
                	pending_subcontractors: {
                		name: 'Pending Subcontractors',
                		key: 'pending_subcontractors',
                		permissions: ['subcontractors.manage'],
                		filter_options: {},
                		filters: {},
                	},
                	safety_meetings: {
                		name: 'Safety Meetings',
                		key: 'safety_meetings',
                		permissions: ['safety.meetings.view.browse', 'safety.meetings.view.own'],
                		filter_options: {
                			timeframe: {
                				options: ['MTD', 'YTD'],
                				label: 'Time Period',
                                type: 'select',
                			},
                		},
                		filters: {
                			timeframe: null,
                		},
                        savedFilterType: 'SafetyMeeting',
                        savedFilterId: null,
                	},
                	incident_types: {
                        name: 'Types w/ Incidents',
                        key: 'incident_types',
                        permissions: ['incidents.manage'],
                        filter_options: {
                            timeframe: {
                                options: ['MTD', 'YTD'],
                                label: 'Time Period',
                                type: 'select',
                            },
                        },
                        filters: {
                            timeframe: null,
                        },
                        savedFilterType: 'Incident',
                        savedFilterId: null,
                        reverse_colors: true,
                    },
                	weather: {
                        name: 'Weather',
                        key: 'weather',
                        permissions: [],
                        filter_options: {
                            city: {
                                options: '/dash/weather-cities',
                                label: 'City',
                                type: 'ajax',
                                placeholder: 'Cities',
                            },
                        },
                        filters: {
                            city: null,
                        },
                        tile_type: 'weather',
                    },
                },
                userId: this.$store.state.user.user_id,
                employeeId: this.$store.state.user.EmployeeId,
                isSubcontractorManager: this.$root.hasPermission('subcontractors.manage'),
            }
        },

        watch: {
            active_cards: {
                deep: true,
                handler(active_cards) {
                    this.$http.post('/dash/current', {dashboard: JSON.stringify(this.active_cards)})
                    .then(response => {

                    })
                    .catch(err => {

                    });
                },
            },
        },

        computed: {
            hasCard() {
                return (this.active_cards[this.curr_index].key != 'weather')
            },
        },

        methods: {
            sortTile(event) {
                if (event.oldIndex == this.curr_index)
                {
                    this.curr_index = event.newIndex;
                }
                else if (event.oldIndex < this.curr_index && event.newIndex >= this.curr_index)
                {
                    this.curr_index--;
                }
                else if (event.oldIndex > this.curr_index && event.newIndex <= this.curr_index)
                {
                    this.curr_index++;
                }
            },

            addTile(bvModalEvt) {
                // Prevent modal from closing
                bvModalEvt.preventDefault()

                //SEtup
                let new_option = JSON.parse(JSON.stringify(this.selected_option));

                //Debugging
                console.log(new_option);

                //Check for a city
                switch(new_option.key)
                {
                    case 'inspection_score':
                    case 'incident_types':
                    case 'safety_meetings':
                    case 'incident_jobsites':
                    case 'inspections':
                    case 'incidents':
                    case 'incident_employees':
                        //Check for both a saved Filter and a timefram
                        if(!new_option.savedFilterId && !new_option.filters.timeframe)
                        {
                            //Alert the user
                            this.$toastr.warning('Select a Time Period or a Saved Filter');

                            //Stop here
                            return false;
                        }
                        break;

                    case 'corrective_actions':
                    case 'employee_disc_actions':
                    case 'employee_recognitions':
                    case 'noncompliant_items':
                        //Check for both a saved Filter and a timefram
                        if(!new_option.filters.timeframe)
                        {
                            //Alert the user
                            this.$toastr.warning('Select a Time Period');

                            //Stop here
                            return false;
                        }
                        break;

                    case 'weather':
                        //Check for a city
                        if(!new_option.filters.city)
                        {
                            //Alert the user
                            this.$toastr.warning('Select a City to add the Weather widget');

                            //Stop here
                            return false;
                        }
                        break;
                }

                //Check for weather
                if (new_option.key == 'weather')
                {
                    this.activateWeatherTile(new_option)
                }

                //Push it
                this.active_cards.push(new_option)
                this.curr_index = this.active_cards.length - 1;

                //Close the model
                this.openModal = false;
            },

        	deleteTile(index)
        	{
                if (index < this.curr_index)
                {
                    this.curr_index--;
                }
                else if (index == this.curr_index)
                {
                    this.curr_index = null;
                }

                this.active_cards.splice(index, 1);
        	},

        	getTileName(card) {
                if (card.savedFilterId)
                {
                    switch (card.key)
                    {
                        case 'safety_meetings':
                        case 'employee_disc_actions':
                        case 'employee_recognitions':
                        case 'noncompliant_items':
                        case 'inspections':
                        case 'incidents':
                        case 'corrective_actions':
                        case 'incident_types':
                        case 'incident_employees':
                        case 'incident_jobsites':
                        case 'inspection_score':
                            return `${card.name} (${this.findSavedFilter(card.savedFilterId).filter_name})`
                            break;
                        case 'weather':
                            return `${card.name} - ${card.filters.city.name}, ${card.filters.city.state}`
                            break;
                        default:
                            return card.name;
                            break;
                    }
                }
                else
                {
                    switch (card.key)
                    {
                        case 'safety_meetings':
                        case 'employee_disc_actions':
                        case 'employee_recognitions':
                        case 'noncompliant_items':
                        case 'inspections':
                        case 'incidents':
                        case 'corrective_actions':
                        case 'incident_types':
                        case 'incident_employees':
                        case 'incident_jobsites':
                        case 'inspection_score':
                            return `${card.name} ${card.filters.timeframe}`
                            break;
                        case 'weather':
                            return `${card.name} - ${card.filters.city.name}, ${card.filters.city.state}`
                            break;
                        default:
                            return card.name;
                            break;
                    }
                }

        		return card.name;
        	},

            activateWeatherTile(card) {
                this.$http.get(`/dash/weather-data?city_id=${card.filters.city.id}`)
                .then(response => {
                    if (response.data)
                    {
                        this.$set(card, 'temp', response.data.main.temp.toFixed(0));
                        this.$set(card, 'icon', response.data.weather[0].icon);
                        // this.$set(card, 'description', response.data.weather[0].description);
                        this.$set(card, 'temp_max', response.data.main.temp_max.toFixed(0));
                        this.$set(card, 'temp_min', response.data.main.temp_min.toFixed(0));
                    }
                })
                .catch(err => {

                });
            },

	    	getCardName(card) {
                if (card.savedFilterId)
                {
                    switch (card.key)
                    {
                        case 'safety_meetings':
                        case 'employee_disc_actions':
                        case 'employee_recognitions':
                        case 'noncompliant_items':
                        case 'inspections':
                        case 'incidents':
                        case 'corrective_actions':
                        case 'incident_types':
                        case 'incident_employees':
                        case 'incident_jobsites':
                        case 'inspection_score':
                            return `${card.name} (${this.findSavedFilter(card.savedFilterId).filter_name})`
                            break;
                        default:
                            return card.name;
                            break;
                    }
                }
                else
                {
                    switch (card.key)
                    {
                        case 'safety_meetings':
                        case 'employee_disc_actions':
                        case 'employee_recognitions':
                        case 'noncompliant_items':
                        case 'inspections':
                        case 'incidents':
                        case 'corrective_actions':
                        case 'incident_types':
                        case 'incident_employees':
                        case 'incident_jobsites':
                        case 'inspection_score':
                            return `${card.name} ${card.filters.timeframe}`
                            break;
                        default:
                            return card.name;
                            break;
                    }
                }

	    		return card.name;
	    	},

            displayOption(key, option)
            {
                switch (key)
                {
                    case 'city':
                        return `${option.name}, ${option.state}`
                }
                return '';
            },

            findSavedFilter(id) {
                for(let i = 0; i < this.$store.state.user.filters.length; i++)
                {
                    if (this.$store.state.user.filters[i].id == id)
                    {
                        return this.$store.state.user.filters[i];
                    }
                }
            },

            savedFilters(type){
                //Setup
                var filters = [];

                //Check the stor
                if(this.$store.state.user.filters)
                {
                    //Loop and build
                    for (var i = this.$store.state.user.filters.length - 1; i >= 0; i--)
                    {
                        //Only add the incidents
                        if(this.$store.state.user.filters[i].asset_type == type)
                        {
                            filters.push(this.$store.state.user.filters[i]);
                        }
                    }
                }

                //Send it
                return filters;
            },

            onSearch: function(searchTerm, searchLoading){
                if (searchTerm.length < 3)
                    return;

                searchLoading(true);

                this.debounce_lock++

                setTimeout(() => {
                    this.debounce_lock--
                    if (this.debounce_lock == 0)
                    {
                        //Send it
                        this.$http.get('/dash/weather-cities', {term: searchTerm})
                        .then(res => {
                            //Set the data
                            this.options = res.data;

                            //Done loading
                            searchLoading(false);
                        });
                    }
                }, 500)
            },

            onChange: function (selected) {
                this.selected_option.filters.city = this.ajax_item;
            },

	    	getCardTextColor(card, selected) {
    			if (card.count > (card.prev_count || 0))
    			{
    				if (card.reverse_colors)
    				{
    					return selected ? 'text-danger' : 'text-danger-muted';
    				}
    				else
    				{
    					return selected ? 'text-success' : 'text-success-muted';
    				}
    			}
    			else if (card.count < (card.prev_count || 0))
    			{
    				if (card.reverse_colors)
    				{
    					return selected ? 'text-success' : 'text-success-muted';
    				}
    				else
    				{
    					return selected ? 'text-danger' : 'text-danger-muted';
    				}
    			}
    			return '';
	    	},
            getCurrentDashboard() {
                this.$http.get('/dash/current')
                .then(response => {
                    if (response.data)
                    {
                        this.active_cards = response.data

                        for(let card of this.active_cards)
                        {
                            if (card.key == 'weather')
                            {
                                this.activateWeatherTile(card);
                            }
                        }
                    }
                    else
                    {
                        //let dash = [this.card_options['my_corrective_actions']];
                        let dash = [];

                        //Corrective Actions
                        next = this.card_options['my_corrective_actions'];
                        if(this.$root.hasPermission(next.permissions))
                        {
                            dash.push(next);
                        }

                        let next = this.card_options['incidents'];
                        next.filters.timeframe = 'MTD';
                        if(this.$root.hasPermission(next.permissions))
                        {
                            dash.push(next);
                        }

                        next = this.card_options['my_equipment'];
                        if(this.$root.hasPermission(next.permissions))
                        {
                            dash.push(next);
                        }

                        next = this.card_options['assigned_equipment'];
                        if(this.$root.hasPermission(next.permissions))
                        {
                            dash.push(next);
                        }

                        next = this.card_options['pending_subcontractors'];
                        if(this.$root.hasPermission(next.permissions))
                        {
                            dash.push(next);
                        }

                        //Check for at least 1 Active Card
                        if(dash.length > 0)
                        {
                            //Send it
                            this.$set(this, 'active_cards', dash);
                        }
                    }
                })
                .catch(err => {

                });
            },

            correctiveActionCount(count){
                //SEt it
                this.actionCount = count;
            },
        },

        mounted() {
            this.getCurrentDashboard();

            setInterval(() => {
                for(let i = 0; i < this.$refs.dashItem.length; i++)
                {
                    this.$refs.dashItem[i].refresh();
                }
                for (let i = 0; i < this.active_cards.length; i++)
                {
                    if (this.active_cards[i].key == 'weather')
                    {
                        this.activateWeatherTile(this.active_cards[i].key);
                    }
                }
            }, 300000);
        }
    }
</script>

<style>
	.text-danger-muted {
		color: #e8928e !important;
	}

	.text-success-muted {
		color: #71c78b !important;
	}
</style>